import { Container, Grid, Link } from "@mui/material";
import React from "react";
import DashBoardFooter from "../../../Components/DashboardFooter";

import logo from "../../../images/logo.png"
import playtable from "../../../images/playtable.png"

const ConnectScreen = (props) => {
    return(
        <div className="AppDapp">
            <Container>
                <Grid
                    container
                    justifyContent='center'
                    alignContent="space-between"
                    className="connectDiv"
                >
                    <Grid
                        xs={12}
                        className="text-center inner"
                    >
                        
                        <Link
                            href="#"
                            type="button"
                            className="MS---Neon--Button btn d-inline-block px-5 m-auto"
                            onClick={props.connectFun}
                        >
                            Connect Wallet
                        </Link>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="mt-sm-5 py-5 px-sm-5"
                    >
                        <Grid
                            xs={12}
                            sm={8}
                            className="text-center text-sm-left"
                        >
                            <p className="mb-0">Metasnooker © 2022. All Rights Reserved.</p>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="text-center text-sm-right mt-4 mt-sm-0"
                        >
                            <Link href="/terms" className="MS---blue-link" target="_blank">
                                Terms & Conditions
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link href="/privacy-policy" className="MS---blue-link" target="_blank">
                                Privacy Policy
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default ConnectScreen;